<template>
    <div>
      <el-dialog
          :visible.sync="show_date_range_dialog">
        Date Range:
        <el-select filterable style="padding-left:10px;" v-model="period" placeholder="Select">
          <el-option
              v-for="duration in durations"
              :key="duration.key"
              :label="duration.label"
              :value="duration.key">
          </el-option>
        </el-select>
        <span v-if="period==='custom'">
                                  From
                                  <el-date-picker
                                      v-model="date_start"
                                      value-format="yyyy-MM-dd"
                                      type="date"
                                      placeholder="Select start date">
                                  </el-date-picker>
                                  To
                                  <el-date-picker
                                      v-model="date_end"
                                      value-format="yyyy-MM-dd"
                                      type="date"
                                      placeholder="Select end date">
                                  </el-date-picker>
                                </span>
      </el-dialog>
        <el-dialog
                title="Change token value"
                :visible.sync="show_token_dialog">

            <el-input placeholder="Enter token" v-model="entered_token_value"></el-input>
            <el-button v-on:click="saveToken">Save</el-button>
            <el-button @click="cancelTokenDialog">Cancel</el-button>
        </el-dialog>

        <el-dialog
            title="Manage Data Sources"
            width="75%"
            :visible.sync="show_custom_data_source_dialog">
            <manage-data-sources :extent_id="selected_extent"/>
        </el-dialog>

      <span>
              CSV <el-switch v-model="is_api_import"></el-switch> API

      </span>

      <div v-if="is_api_import">
        <div style="margin-top:5px;margin-bottom:5px;">
          Note: Only GA4 and Matomo are set up now via the UI,
          although Adobe Analytics can be set up for you in the backend.
        </div>
      </div>
      <div v-else>
        <el-upload
            style="margin-top:10px;"
            drag
            :on-success="afterSuccessfulUpload"
            action="/api/uploads">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
          <div class="el-upload__tip" slot="tip">Upload CSVs up to 2GB.</div>
        </el-upload>
      </div>
      <div>
        <el-select filterable v-model="selected_data_source" value-key="id" placeholder="Select data source">
          <el-option
              v-for="item in filtered_data_sources"
              :label = "item.source_name"
              :value = "item">
          </el-option>
        </el-select>
        <div>{{address_prefix_message}}</div>
          <job-chain-start-button
              button_label="Start Merging"
              :extent_id="this.selected_extent"
              :date_start="this.date_start"
              :date_end="this.date_end"
              :period="this.period"
              :data_source_id="this.selected_data_source.id"
              type="merge"
              :upload_file="this.upload_file"
          />
        <el-button @click="showTokenDialog" v-show="show_token_button">Change token value</el-button>
        <div style="display:inline-block;">
          <el-button @click="openDataSourceDialog" icon="el-icon-setting"></el-button>
          <el-button v-if="show_date_range_button" @click="inititate_show_date_range_dialog" icon="el-icon-date"></el-button>
        </div>
      </div>

    </div>
</template>

<script>
    import ElOption from "../../../../node_modules/element-ui/packages/select/src/option.vue";
    import ExtentList from '../old/ExtentListOld.vue'

    export default {
        props: ['selected_extent'],
        components: {ElOption},
        mounted() {
            axios.get('/api/dataSources/date_ranges')
                .then(response => {
                  this.durations = response.data
                  // console.log(this.data_sources)
                })
                .catch(error => {
                  console.log('oops getting data range options')
                })
            // console.log('Component mounted now.')
            if (this.selected_extent) {
                this.loadExtent()
            } else {
                axios.get('/api/dataSources')
                    .then(response => {
                        this.data_sources = response.data
                        // console.log(this.data_sources)
                    })
                    .catch(error => {
                        console.log('oops getting data sources')
                    })
            }
            if (chimera.permissions.includes('BLEEDING_EDGE')) this.show_bleeding_edge = true
            if (chimera.features.includes('over_time')) this.show_date_range_button = true
        },
        watch: {
            selected_extent: function(val) {
                this.loadExtent()
            }
        },
        computed: {
            filtered_data_sources: function() {
              if (this.is_api_import) {
                return this.data_sources.filter(source => {return source.integration_type;})
              } else {
                return this.data_sources
              }
            },
            address_prefix_message: function () {
                let msg = ""
                if (this.selected_data_source) {
                    let prefix = this.selected_data_source.address_prefix
                    let token_value = this.selected_data_source.address_prefix_value
                    if (this.confirmed_new_token_value) {
                        token_value = this.confirmed_new_token_value
                    }
                    if (prefix && prefix.charAt(0) === "[") {
                        if (token_value) {
                            msg = "This data source uses a token for the address prefix. The token is " + prefix +
                                " and the value for this extent is " + token_value + "."
                        } else {
                            msg = "This data source uses a token for the address prefix. " +
                                " You need to set the prefix before proceeding." +
                                " For Google Analytics, the value should be something like https://davidhobbsconsulting.com (with no /)" +
                                " since in Google Analytics the domain is normally stripped and all URLs in GA start with /."
                        }
                    } else {
                        msg = prefix
                    }
                }
                return msg
            },
            show_token_button: function() {
                return this.address_prefix_message // Used to only show in bleeding edge case
            },
        },
        data() {
            return {
                durations: null,
                is_api_import: false,
                date_start: null,
                date_end: null,
                period: null,
                show_date_range_button: false,
                show_date_range_dialog: false,
                extents: '',
                data_sources: [],
                selected_data_source: {id: null},
                upload_file: '',
                percentage: 0,
                show_bleeding_edge: false,
                show_token_dialog: false,
                entered_token_value: null,
                confirmed_new_token_value: null,
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() > Date.now();
                    },
                    shortcuts: [{
                        text: 'Today',
                        onClick(picker) {
                            picker.$emit('pick', new Date());
                        }
                    }, {
                        text: 'Yesterday',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24);
                            picker.$emit('pick', date);
                        }
                    }, {
                        text: 'A week ago',
                        onClick(picker) {
                            const date = new Date();
                            date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', date);
                        }
                    }]
                },
                show_custom_data_source_dialog: false,

            }
        },
        methods: {
            inititate_show_date_range_dialog() {
              this.show_date_range_dialog = true
            },
            startImport() {
                // console.log("selected extent:")
                // console.log(this.selected_extent);
                // console.log("selected data source:")
                // console.log(this.selected_data_source);
                // console.log("uploaded file:")
                // console.log(this.upload_file)
                // console.log("date of data:")
                // console.log(this.date_of_data)
                axios.post('/api/jobChains', {
                    extent_id: this.selected_extent,
                    date_start: this.date_start,
                    date_end: this.date_end,
                    period: this.period,
                    data_source_id: this.selected_data_source.id,
                    type: "merge",
                    upload_file: this.upload_file
                }).then(response => {
                    // console.log(response)
//                    window.location.href = '/progress/'
                    // need to come back so that we pass the job chain to progress
                    window.location.href = '/progress/' + response.data.job_chain_id
                }).catch(error => {
                    console.log('oops problem starting import')
                    console.log(error.response)
                })
                //
            },
            showTokenDialog: function() {
                this.show_token_dialog = true
            },
            cancelTokenDialog: function() {
                this.show_token_dialog = false
            },
            saveToken: function() {
                axios.post('/api/dataSources/token/' + this.selected_extent, {
                    token_value: this.entered_token_value,
                    token_name: this.selected_data_source.address_prefix
                })
                    .then(response => {
                        this.confirmed_new_token_value = this.entered_token_value
                        this.show_token_dialog = false
                        // console.log(this.data_sources)
                    })
                    .catch(error => {
                        console.log('oops cats')
                    })
            },
            handleCheckChangeParent(selected_extent) {
                // console.log("handling check change from child")
                // console.log("select extent id back in parent:")
                // console.log(selected_extent)
                this.selected_extent = selected_extent.id
            },
            afterSuccessfulUpload(response, file, fileList) {
                // console.log("successful upload")
                // console.log("response")
                // console.log(response)
                this.upload_file = response
            },
            loadExtent() {
                axios.get('/api/dataSources/' + this.selected_extent)
                    .then(response => {
                        this.data_sources = response.data
                        // console.log(this.data_sources)
                    })
                    .catch(error => {
                        console.log('oops cats')
                    })
            },
            openDataSourceDialog() {
              this.show_custom_data_source_dialog = true
            },

        }
    }
</script>
